
import { useEffect, useRef, useState } from 'react'
import IScalarForm from '../interface/IScalarForm'
import Scalar from './Scalar'
import {Slider as MSlider, NumericInput} from "@blueprintjs/core"

const Slider = (props: IScalarForm) : JSX.Element => {
    return <Scalar 
        { ...props } 
        enabledForm={<SliderEnabled {...props} />}
        desabledForm={<SliderDesabled {...props} />}
    />
} 
export default Slider 

export const SliderEnabled = ( props: IScalarForm ): JSX.Element => { 
    const ref = useRef<HTMLDivElement>(null)
    const [className, setClassName] = useState<string>( "flex-column" )
    useEffect(() => {
        const div: HTMLDivElement = ref.current as HTMLDivElement
        if(!!div) {
            setClassName( div.clientWidth < 250 ? "flex-column" : "flex-row" )
        }
    }, [])
    const onChange = (value: number) => { 
        if( props.onChange )
        {
            props.onChange( value,  props.field, "" )
        }   
    }

    return <div className={` d-flex ${ className } justify-content-center my-3 mx-3 w-100 py-0 `} style={{ gap: 10 }} onDrag={(evt => { evt.preventDefault() })} ref={ref}>
        <MSlider
          min={ props.min ? props.min : 0}
          max={ props.max ? props.max : 100}
          stepSize={ props.stepSize ?  props.stepSize : 10}
          labelStepSize={
					props.labelStepSize
					  ? 
                      props.labelStepSize
					  : 
                      props.stepSize
					    ? 
                        props.stepSize
					    : 
                        20
				}
          value={
            parseFloat(props.value || props.default || 0) || ( props.min && props.min > 0
					  ? 
                      props.min
					  : 
                      0
                    )
				}
          onChange={ onChange }
          className="mr-3"
        />
        {
            !props.disabledLabel && <NumericInput
                onValueChange={ onChange }
                value={ props.value || props.default || 0 }
                min={ props.min }
                max={ props.max }
                data-testid="scalar-slider-number"
                stepSize={ props.stepSize }
                size="small" 
                inputClassName='form-control input dark bg-transparent border box-shadow-none width-50 min-height-40'
            /> 
        } 
    </div>
} 
 
const SliderDesabled = ( props: IScalarForm ): JSX.Element => {
    return <div className='my-3 text-center '>{props.value }</div>
} 
 